module.exports = __webpack_public_path__ + "img/arrow_impetus_green.b94326ef.png";